export enum ModalName {
  ServicePrincipal = 'AddOrUpdateServicePrincipalModal',
  ServicePrincipalDetail = 'ServicePrincipalDetailModal',
}
